export const GET_TENANT_ADMINS = "GET_TENANT_ADMINS";

export const  CREATE_UPDATE_TENANT_STATUS = "CREATE_UPDATE_TENANT_STATUS";